// Style helper: show the uploaded cover image if there is one, else the colour.
export function coverBg(url, color) {
  const c = color || "#3a5a6b";
  if (!url) return { background: c };
  const safe = String(url).replace(/"/g, "%22");
  return { background: `url("${safe}") center / cover no-repeat, ${c}` };
}
export default coverBg;